<template>
  <FullScreenPopup
    ref="popup"
    title="Філії"
    :lock-scroll="true"
  >
    <div class="company-branches-popup">
      <CompanyBranchesListSelector
        :company-id="companyId"
        @change="onChangeCompanyBranch"
      />
      <Divider type="horizontal" />

      <div
        v-for="(branch, index) in selectedBranches"
        :key="index"
        class="company-branch-info__wrapper"
      >
        <div class="company-branch-info__column company-branch-info__column--address">
          <span class="company-branch-info__subtitle">{{ branch.type }}</span>
          {{ branch.address }}
        </div>
        <div class="company-branch-info__column company-branch-info__column--working-time">
          <span class="company-branch-info__subtitle">Графік роботи</span>
          {{ branch.workingTime }}
        </div>
        <div class="company-branch-info__column company-branch-info__column--contacts">
          <span class="company-branch-info__subtitle">Контакти</span>
          {{ branch.contacts }}
        </div>

        <Divider v-if="index !== selectedBranches.length - 1" type="horizontal" />
      </div>
    </div>
  </FullScreenPopup>
</template>

<script>
import { CompanyBranchesListSelector } from '@/features/selectors';
import { Divider } from '@/shared/ui/divider';
import { FullScreenPopup } from '@/shared/ui/popup';

export default {
  props: {
    companyId: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      selectedBranches: null,
    };
  },
  components: { FullScreenPopup, CompanyBranchesListSelector, Divider },
  methods: {
    open() {
      this.$refs.popup.open();
    },
    togglePopup() {
      this.$refs.popup.togglePopup();
    },
    close() {
      this.$refs.popup.close();
    },
    onChangeCompanyBranch(branches) {
      this.selectedBranches = branches;
    },
  },
};
</script>

<style scoped lang="scss">
.company-branches-popup {
  padding: 16px;
}

.company-branch-info {
  &__wrapper {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 20px;
    margin-bottom: 16px;
  }

  &__column {
    font-size: 16px;
    font-weight: 500;
    color: #09090B;
    flex: 1;
    min-width: 150px;

    &--address {
      flex: 1.5;
    }
  }

  &__subtitle {
    font-weight: 400;
    font-size: 14px;
    margin-bottom: 4px;
    display: block;
    color: #717680;
  }
}

::v-deep .fullscreen-popup__content-wrapper {
  max-width: 500px;
}
</style>
